(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beats-store"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.beats-page').forEach(page => {
  const fitPlayer = () => page.style.setProperty('--beats-top-space', `${Math.max(0, page.getBoundingClientRect().top + window.scrollY)}px`);
  fitPlayer();
  window.addEventListener('resize', fitPlayer, { passive: true });
  const header = document.querySelector('.site-header');
  if (header) new ResizeObserver(fitPlayer).observe(header);
});

  } catch(e) { console.error(e); }
})();
})();
